/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import arr_methodsImg from 'assets/images/arr-methods.jpeg'
import pushImg from 'assets/images/push.png'
import popImg from 'assets/images/pop.png'
import sliceImg from 'assets/images/slice.png'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Методы массива</h2>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.1 - Методы split() и join()</h3>
      <p className={styles.description}>
        <code className={styles.code}>split(s)</code> — позволяет превратить строку в массив, разбив ее по разделителю{' '}
        <code className={styles.code}>s</code>. Это не метод массива, но рассматриваем мы его сейчас так как раньше мы о
        массивах не знали.
      </p>
      <p className={styles.description}>
        <code className={styles.code}>join(s)</code> — делает в точности противоположное{' '}
        <code className={styles.code}>split</code>. Он берет массив и склеивает его в строку, используя{' '}
        <code className={styles.code}>s</code> как разделитель.
      </p>
      <CopyBlock
        text={`// split
const message = 'Welcome to Bahamas!';

// Разбивает строку по разделителю, в данном случае это пробел
console.log(message.split(' ')); // ["Welcome", "to", "Bahamas!"]

// Вызов split с пустой строкой разобьёт по буквам
console.log(message.split('')); // [много букв :)]

// join
const clients = ['Mango', 'Poly', 'Ajax'];

// Сошьет все элементы массива в строку,
// между каждой парой элементов будет указанный разделитель
console.log(clients.join(' ')); // "Mango Poly Ajax"
console.log(clients.join(',')); // "Mango,Poly,Ajax"
console.log(clients.join('-')); // "Mango-Poly-Ajax"`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.2 - Методы indexOf() и includes()</h3>
      <p className={styles.description}>
        <code className={styles.code}>array.indexOf(x)</code> — возвращает первый индекс, в котором элемент{' '}
        <code className={styles.code}>x</code> был найден в массиве, или число <code className={styles.code}>-1</code>,
        если такого элемента нет. Используйте <code className={styles.code}>indexOf</code> тогда, когда необходимо
        получить непосредсвенно индекс элемента.
      </p>
      <CopyBlock
        text={`const clients = ['Mango', 'Ajax', 'Poly', 'Kiwi'];

console.log(clients.indexOf('Poly')); // 2
console.log(clients.indexOf('Monkong')); // -1`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <p className={styles.description}>
        <code className={styles.code}>array.includes(x)</code> — определяет, содержит ли массив некоторый элемент{' '}
        <code className={styles.code}>x</code>, возвращая <code className={styles.code}>true</code> или{' '}
        <code className={styles.code}>false</code> соответственно. Используйте{' '}
        <code className={styles.code}>includes</code> тогда, когда необходимо проверить есть ли элемент в массиве и не
        важен его порядковый номер.
      </p>
      <CopyBlock
        text={`const clients = ['Mango', 'Ajax', 'Poly', 'Kiwi'];

console.log(clients.includes('Poly')); // true
console.log(clients.includes('Monkong')); // false`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <section className={styles.subsection}>
        <h4 className={styles.h4}>3.2.1 - Проверка множественных условий с includes()</h4>
        <p className={styles.description}>
          На первый взгляд пример ниже выглядит вполне хорошо. Однако, что если у нас будет больше красных фруктов, к
          примеру ещё вишня (cherry) или клюква (cranberries)? Будем ли мы расширять условие с помощью дополнительных{' '}
          <code className={styles.code}>||</code>?
        </p>
        <CopyBlock
          text={`const fruit = 'apple';

if (fruit === 'apple' || fruit === 'strawberry') {
  console.log('It is a red fruit!');
}`}
          language="javascript"
          showLineNumbers={false}
          theme={ocean}
        />
        <p className={styles.description}>
          Можем переписать условие, с использованием <code className={styles.code}>Array.includes</code>, это очень
          просто и масштабируемо.
        </p>
        <CopyBlock
          text={`// Выносим варианты в массив
const redFruits = ['apple', 'strawberry', 'cherry', 'cranberries'];
const fruit = 'cherry';

if (redFruits.includes(fruit)) {
  сonsole.log('It is a red fruit!');
}`}
          language="javascript"
          showLineNumbers={false}
          theme={ocean}
        />
      </section>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.3 - Методы push(), pop(), shift(), unshift()</h3>
      <p className={styles.description}>
        Добавляют или удаляют крайние элементы массива. Работают только с крайним левым и крайним правым элементом
        массива, и не могут поставить или удалить элемент с произвольной позиции. Для наглядности взягляните на
        иллюстрацию ниже.
      </p>
      <img className={styles.img} src={arr_methodsImg} alt="arr-methods" />
      <section className={styles.subsection}>
        <h4 className={styles.h4}>3.3.1 - push и pop</h4>
        <p className={styles.description}>
          <code className={styles.code}>push()</code> — позволяет добавить один или несколько элементов в конец массива.
          Метод возвращает значение свойства <code className={styles.code}>length</code>, которое определяет количество
          элементов в массиве.
        </p>
        <img className={styles.img} src={pushImg} alt="push" />
        <p className={styles.description}>
          <code className={styles.code}>pop()</code> — удаляет элемент из конца массива и возвращает удаленный элемент.
          Если массив пуст, метод возвращает <code className={styles.code}>undefined</code>.
        </p>
        <img className={styles.img} src={popImg} alt="pop" />
        <p className={styles.description}>
          В примере кодом описаны иллюстрации выше, первые 3 шага. Создается пустой массив с именем{' '}
          <code className={styles.code}>stack</code> и в конец массива добавляется три числа, одно за другим используя{' '}
          <code className={styles.code}>push()</code>, затем они удаляются используя{' '}
          <code className={styles.code}>pop()</code>.
        </p>
        <CopyBlock
          text={`// Создаем пустой массив
const stack = [];

// Добавляем элементы в конец массива
stack.push(1);
console.log(stack); // [1]

stack.push(2);
console.log(stack); // [1, 2]

stack.push(3);
console.log(stack); // [1, 2, 3]

// Удаляем элементы из конца массива
console.log(stack.pop()); //  3
console.log(stack); // [1, 2]

console.log(stack.pop()); //  2
console.log(stack); // [1]

console.log(stack.pop()); //  1
console.log(stack); // []

console.log(stack.pop()); //  undefined`}
          language="javascript"
          showLineNumbers={false}
          theme={ocean}
        />
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>3.3.2 - shift() и unshift()</h4>
        <p className={styles.description}>
          Реже используются методы <code className={styles.code}>shift</code> и{' '}
          <code className={styles.code}>unshift</code>.
        </p>
        <ul className={styles.list}>
          <li className={styles.list__item}>
            <code className={styles.code}>shift()</code> — удаляет элемент из начала массива и возвращает его (элемента)
            значение.
          </li>
          <li className={styles.list__item}>
            <code className={styles.code}>unshift()</code> — добавляет элемент в начало массива.
          </li>
        </ul>
        <CopyBlock
          text={`const clients = ['Mango', 'Ajax', 'Poly'];

console.log(clients.shift()); // Mango
console.log(clients); // ["Ajax", "Poly"]

clients.unshift('Kiwi');
console.log(clients); // ["Kiwi", "Ajax", "Poly"]`}
          language="javascript"
          showLineNumbers={false}
          theme={ocean}
        />
      </section>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.4 - Метод slice()</h3>
      <p className={styles.description}>
        Синтаксис метода <code className={styles.code}>slice()</code> одинаков для строк и массивов. Его просто
        запомнить. Он позволяет извлекать элементы подмножества массива и добавлять их в новый массив. В большинстве
        случаев используется для создания копии части или целого исходного массива.
      </p>
      <CopyBlock text={`slice(begin, end)`} language="javascript" showLineNumbers={false} theme={ocean} />
      <p className={styles.description}>
        Копирует элементы от <code className={styles.code}>begin</code>, до, но не ключая,{' '}
        <code className={styles.code}>end</code>.
      </p>
      <img className={styles.img} src={sliceImg} alt="slice" />
      <ul className={styles.list}>
        <li className={styles.list__item}>
          Оба аргумента ( <code className={styles.code}>begin</code> и <code className={styles.code}>end</code>) не
          обязательны.
        </li>
        <li className={styles.list__item}>
          Параметр <code className={styles.code}>begin</code> определяет индекс, с которого следует начинать извлечение.
        </li>
        <li className={styles.list__item}>
          Параметр <code className={styles.code}>end</code>, определяет индекс элемента, на котором следует закончить
          извлечение. Метод <code className={styles.code}>slice</code> не включает элемент с идексом{' '}
          <code className={styles.code}>end</code> в извлеченные элементы.
        </li>
        <li className={styles.list__item}>
          Если <code className={styles.code}>begin</code> и <code className={styles.code}>end</code> не указаны,
          копирование будет с начала массива, с индекса <code className={styles.code}>0</code>, - тоесть скопируется
          весь массив.
        </li>
        <li className={styles.list__item}>
          Если не указать параметр <code className={styles.code}>end</code>, метод{' '}
          <code className={styles.code}>slice</code> будет использовать длину массива (
          <code className={styles.code}>length</code>) для параметра <code className={styles.code}>end</code>.
        </li>
        <li className={styles.list__item}>
          Метод <code className={styles.code}>slice</code> не изменяет исходный массив, а возвращает новый массив,
          содержащий копию элементов исходного.
        </li>
        <li className={styles.list__item}>Можно использовать отрицательные индексы, они отсчитываются с конца.</li>
      </ul>
      <CopyBlock
        text={`const clients = ['Mango', 'Ajax', 'Poly', 'Kiwi'];

// Вернет новый массив в котором будут элементы с индексами от 1 до 2
console.log(clients.slice(1, 3)); // ["Ajax", "Poly"]

// Вернет новый массив в котором будут
// элементы с индексами от 1 до (clients.length - 1)
console.log(clients.slice(1)); // ["Ajax", "Poly", "Kiwi"]

// Вернет копию исходного массива
console.log(clients.slice()); // ["Mango", Ajax", "Poly", "Kiwi"]

// Вернет новый массив состоящих из последних двух элементом исходного
console.log(clients.slice(-2)); // ["Poly", "Kiwi"]`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.5 - Метод concat()</h3>
      <p className={styles.description}>
        Используется для объединения двух или более массивов. Этот метод не изменяет исходный массив, а возвращает
        новый.
      </p>
      <CopyBlock
        text={`const oldClients = ['Mango', 'Ajax', 'Poly', 'Kiwi'];
const newClients = ['Monkong', 'Singu'];

const allClients = oldClients.concat(newClients);

console.log(allClients);
// ["Mango", "Ajax", "Poly", "Kiwi", "Monkong", "Singu"]

console.log(oldClients);
// ["Mango", "Ajax", "Poly", "Kiwi"]

console.log(newClients);
// ["Monkong", "Singu"]`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>
  </section>
))
